import { useEffect, useState } from "react";

import {
  ICitationAuthor,
  IReturnCitationContributors,
} from "../../CitationAction.interface";
import {
  formBlockCss,
  subTitleCss,
} from "./CitationEditFormContributors.style";

import CitationEditFormAuthor from "./CitationEditFormAuthor/CitationEditFormAuthor";

interface CitationEditFormContributorsProps {
  authors: ICitationAuthor[];
  touched: boolean;
  handleContributorsReturn: (data: IReturnCitationContributors) => void;
}

const CitationEditFormContributors = ({
  authors,
  touched,
  handleContributorsReturn,
}: CitationEditFormContributorsProps) => {
  const [authorsValue, setAuthorsValue] = useState<ICitationAuthor[]>(authors);

  useEffect(() => {
    handleContributorsReturn({ authors: authorsValue });
  }, [authorsValue]);

  const handleAuthorChange = (author: ICitationAuthor, index: number) => {
    const updatedAuthors = [...authorsValue];
    updatedAuthors[index] = author;
    setAuthorsValue([...updatedAuthors]);
  };

  return (
    <div css={formBlockCss}>
      <h4 css={subTitleCss}>Contributors</h4>
      {authors.map((author, index) => (
        <CitationEditFormAuthor
          key={`CitationEditFormAuthor-${index}`}
          author={author}
          index={index}
          touched={touched}
          handleAuthorReturn={handleAuthorChange}
        />
      ))}
    </div>
  );
};

export default CitationEditFormContributors;
